<template>
  <div class="collect">
    <Header :title="{name: '我的收藏'}"></Header>
    <van-tabs @change="onTabChange">
      <van-tab v-for="(item, index) in tabs" :key="index" :title="item.name"></van-tab>
    </van-tabs>
    <Empty :empty_type="{name: '暂无收藏'}" v-if="list.length == 0" style="margin-top:20vw;"></Empty>
    <div class="content">
      <List
        ref="list"
        url="/api/app/collect"
        method="get"
        :params="{type: this.type}"
        :on-formatter="onFormatter"
        :on-getdata="onGetdata"
        :showText="list.length > 0"
      >
        <template slot="item">
          <div v-if="type == 1">
            <div class="item" v-for="(item, index) in list" :key="index" @click="onItem(item)">
              <div class="collect-icon" @click.stop="onUnstar(item)"></div>
              <div class="top">
                <p class="title">{{item.title}}</p>
                <p class="time">
                  <span class="duration" v-if="$pub.showDuration(item.course_type)">
                    <img class="clock" src="@/assets/images/icon-time.png" alt />
                    <span>{{item.start_play_date | fomartTime('MM月dd日 hh:mm')}} ~ {{item.end_play_date | fomartTime('MM月dd日 hh:mm')}}</span>
                  </span>
                  <span>共{{item.section_num}}课时</span>
                </p>
                <ul class="teachers">
                  <li v-for="(teacher, index) in item.teacherAry" :key="index">
                    <img :src="teacher.avatar" />
                    <span>{{teacher.name}}</span>
                  </li>
                </ul>
              </div>
              <div class="bottom">
                <div class="info">
                  <p class="sign">{{item.sales_num}}人已报名</p>
                  <div class="price">
                    <p class="price-line" v-if="item.underlined_price">
                      <icon-price size="mini"></icon-price>
                      {{item.underlined_price | toFixPrice}}
                    </p>
                    <p class="price-now">
                      <icon-price size="mini"></icon-price>
                      {{item.price | toFixPrice}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="type == 4">
            <van-swipe-cell v-for="(book,index) in list" :key="index">
              <div class="bl-item" @click="goBook(book.book_id)">
                <img class="bli-cover" :src="book.cover_img" alt />
                <div>
                  <div>
                    <p class="bli-title">{{book.book}}</p>
                    <p class="bli-author">{{book.author}}</p>
                  </div>
                  <p class="bli-price">
                    <icon-price size="mini" :priceType="2"></icon-price>
                    {{book.price | toFixPrice}}
                  </p>
                </div>
              </div>
              <template slot="right">
                <van-button
                  @click="onUnstar(book)"
                  class="btn-delete"
                  square
                  type="danger"
                  text="取消收藏"
                />
              </template>
            </van-swipe-cell>
          </div>
        </template>
      </List>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Empty from "@/components/Empty";
import List from "@/components/List";
export default {
  name: "collect",
  components: {
    Header,
    Empty,
    List
  },
  data() {
    return {
      list: [],
      tabs: [{ name: "课程", type: 1 }, { name: "图书", type: 4 }],
      type: 1
    };
  },
  methods: {
    goBook(id) {
      this.$router.push({
        name: "BookDetail",
        query: {
          id
        }
      });
    },
    onTabChange(index) {
      this.type = this.tabs[index].type;
      this.$refs.list.reset();
    },
    // on event
    onFormatter(rows) {
      rows.forEach(i => {
        if (i.teachers && i.teachersAvatar) {
          const tNames = i.teachers.split(",");
          const tAvatars = i.teachersAvatar.split(",");
          i.teacherAry = [];
          for (let m = 0; m < tNames.length && m < 3; ++m) {
            i.teacherAry.push({
              name: tNames[m],
              avatar: tAvatars[m]
            });
          }
        }
      });
    },
    onGetdata(data) {
      this.list = data;
    },
    onItem(item) {
      this.$pub.InAppPage("CourseDetail", {
        id: item.course_id,
        courseType: item.course_type
      });
    },
    onUnstar(item) {
      this.$http
        .put(`/api/app/collect/cancel/${item.collect_id}/${this.type}`)
        .then(() => {
          this.$toast({
            message: "取消收藏成功",
            position: "bottom",
            duration: 1500
          });
          setTimeout(() => {
            this.$refs.list.reset();
          }, 500);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.collect {
  @extend %default-bg;
  .content {
    padding: 30px 20px;
    .item {
      background-color: #fff;
      padding: 20px;
      margin-bottom: 20px;
      border-radius: 10px;
      position: relative;
      .collect-icon {
        background: url("~@/assets/theme-img/icon-star.png") no-repeat center;
        background-size: 28px 28px;
        width: 60px;
        height: 60px;
        float: right;
      }
      .top {
        .title {
          font-size: 32px;
          font-weight: 500;
          color: #000;
        }
        .time {
          margin-bottom: 60px;
          font-size: 24px;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          margin-top: 20px;

          .duration {
            margin-right: 20px;
            position: relative;
            * {
              vertical-align: middle;
            }
            .clock {
              width: 28px;
              height: 28px;
              margin-right: 10px;
            }
            &::after {
              content: "";
              display: block;
              width: 1px;
              height: 20px;
              position: absolute;
              top: 50%;
              right: -10px;
              transform: translateY(-50%);
              background-color: #999;
            }
          }
        }
        .teachers {
          display: flex;
          justify-content: flex-start;
          margin-top: 50px;
          li {
            img {
              width: 56px;
              height: 56px;
              border-radius: 50%;
              vertical-align: middle;
            }
            span {
              font-size: 22px;
              color: rgba(0, 0, 0, 0.45);
              vertical-align: middle;
              margin-left: 15px;
              display: inline-block;
              width: 120px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }
      .bottom {
        border-top: 1px solid #f5f5f5;
        margin-top: 30px;
        padding-top: 10px;
        .info {
          .sign {
            font-size: 24px;
            color: rgba(0, 0, 0, 0.45);
            display: inline-block;
            text-align: left;
          }
          .price {
            float: right;
            .price-line {
              font-size: 24px;
              color: rgba(0, 0, 0, 0.45);
              text-decoration: line-through;
              display: inline-block;
            }
            .price-now {
              font-size: 35px;
              color: #ee1f1f;
              display: inline-block;
              &::first-letter {
                font-size: 24px;
              }
            }
          }
        }
      }
    }
    .bl-item {
      height: 262px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.07);
      border-radius: 12px;
      display: flex;
      padding-left: 30px;
      margin-bottom: 30px;
      &:last-child {
        margin: 0;
      }
      .bli-cover {
        width: 144px;
        height: 202px;
        margin-top: 30px;
        margin-right: 30px;
      }
      > div {
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        .bli-title {
          margin-top: 30px;
          font-size: 28px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(89, 89, 89, 1);
          line-height: 44px;
          max-height: 88px;
          overflow: hidden;
        }
        .bli-author {
          font-size: 22px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(140, 140, 140, 1);
          line-height: 44px;
        }
        .bli-price {
          font-size: 22px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(238, 31, 31, 1);
          line-height: 32px;
          padding-bottom: 30px;
        }
      }
    }
    .btn-delete {
      width: 118px;
      height: 100%;
      background: rgba(65, 105, 255, 0.08);
      font-size: 30px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(65, 105, 255, 1);
      line-height: 42px;
      padding: 0 20px;
    }
  }
}
</style>